export default {
  wordAudio(word,item){
    let audio = window.document.createElement("audio");
    word = word.replace(/<u>/g,"").replace(/<\/u>/g,"");
    audio.setAttribute("src", `https://dict.youdao.com/dictvoice?audio=${word}&type=1`);
    audio.setAttribute("autoplay", "autoplay");
		audio.addEventListener('ended', function () {  
			item.apply_blon = false;
		}, false);
  },
  playAudio(src){
    let audio = window.document.createElement("audio");
    audio.setAttribute("src", src);
    audio.setAttribute("autoplay", "autoplay");
  },
	per(){
		var _viewport=document.body.clientWidth;
		_viewport=_viewport>1920?1920:_viewport;
		return _viewport>1920?1:_viewport/1920;
  },
  storageGet(key) {
    let v = localStorage.getItem(key);
    if (!v) {
        return null;
    }
    if (v.indexOf('obj-') === 0) {
      v = v.slice(4);
      return JSON.parse(v);
    } else if (v.indexOf('str-') === 0) {
      return v.slice(4);
    }
  },
  storageSet(key, data) {
    let v = data;
    if (typeof v == 'object') {
        v = JSON.stringify(v);
        v = 'obj-' + v;
    } else {
        v = 'str-' + v;
    }
    localStorage.setItem(key, v);
  },
  storageRemove(key) {
    //删除逻辑要进行获取判断验证
    localStorage.removeItem(key);
    // return this.get(key) === null ? true : false;
  },
  storageClear() {
    localStorage.clear();
  },
  sessionGet(key){
    let v =  sessionStorage.getItem(key);

    if (!v) {
      return null;
  }
  if (v.indexOf('obj-') === 0) {
    v = v.slice(4);
    return JSON.parse(v);
  } else if (v.indexOf('str-') === 0) {
    return v.slice(4);
  }
  },
  sessionSet(key,value){
    let v = value;
    if (typeof v == 'object') {
        v = JSON.stringify(v);
        v = 'obj-' + v;
    } else {
        v = 'str-' + v;
    }
    sessionStorage.setItem(key, v);
  },
  checkUser(){
    
    let that = this;
    let userinfo = that.storageGet("userinfo");
    return userinfo;
  },
  formatSecond(second){
    let _s = second%60;
    if(_s< 10){
      return "0" + _s;
    }
    return _s;
  },
  formatMinutes(second){
    let _s = parseInt(second/60);
    if(_s< 10){
      return "0" + _s;
    }
    return _s;
  },
  getJifenByScore(score){
    let jifen =1;
    if(score >= 60 && score < 80){
      jifen = 5;
    }else if(score >= 80 && score < 100){
      jifen = 8;
    }else if(score == 100){
      jifen = 10;
    }

    return jifen;

  },
}
